<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink } from 'vue-router'

const { to } = defineProps<{ to?: any; href?: any }>()

const isInternalLink = computed(() => {
  // to = undefined -> <a>
  if (to === null || to === undefined) {
    return false
  }

  // to = 'https://...' -> <a>
  // to = '/users/...' or '' -> <router-link>
  if (typeof to === 'string') {
    return to.startsWith('/') || !to.length
  }

  // to = { name: '...' } -> <router-link>
  return true
})
</script>

<template>
  <router-link v-if="isInternalLink" :to="to">
    <slot />
  </router-link>

  <a v-else :href="href">
    <slot />
  </a>
</template>
